import { render, staticRenderFns } from "./tome.vue?vue&type=template&id=ef4627d6&scoped=true&"
import script from "./tome.vue?vue&type=script&lang=js&"
export * from "./tome.vue?vue&type=script&lang=js&"
import style0 from "./tome.vue?vue&type=style&index=0&id=ef4627d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4627d6",
  null
  
)

export default component.exports